import { useContext, useEffect, useState } from 'react';
import { getCustomisationFieldData, getCustomisationValue } from '../../../EditablePreview/EditablePreview';
import { changeStringFieldValue } from '../../ModuleList';
import ModuleTextInput from '../../components/ModuleTextInput';
import { CampaignContext } from "../../../../../../../contexts/CampaignContext";

import { slideOutPanelControl } from '../../../../../../../containers/TimelineEditor/slideout-panel/SlideoutPanel';
import AddButton from '../../../AddButton/AddButton';

const FontSelectField = (props) => {
    const fieldData = props.fieldData;
    const customisationVars = props.customisationVars;

    const [campaignContext, setCampaignContext] = useContext(CampaignContext);

    let optionsData = null;
    if (fieldData?.customFieldConfig?.dataLink) {
        optionsData = getCustomisationFieldData(campaignContext.campaignData, props.selectedFeatureNode.path, fieldData.customFieldConfig.dataLink);
    }

    const initialValue = getCustomisationValue(customisationVars, fieldData?.customFieldConfig?.dataLink, props.index ?? 0, props.visualisationComponentKey ?? null, props.selectedFeatureNode);
    const [currentValue, setCurrentValue] = useState(initialValue);
    useEffect(() => {
        setCurrentValue(initialValue);
    }, [customisationVars, fieldData, props.index, props.visualisationComponentKey, props.selectedFeatureNode, initialValue]);

    const changeFontFace = (value) => {
        if (fieldData?.customFieldConfig?.dataLink) {
            if (changeStringFieldValue(customisationVars, fieldData?.customFieldConfig, value, props.index ?? 0, props.visualisationComponentKey ?? null, props.selectedFeatureNode)) {
                setCurrentValue(value);
                props?.forceUpdateComponent?.();
            }
        }
    }

    return (
        <>
            <div className={`v2-module-field-label${!props.isEnabled ? ' disabled' : ''}`}>{fieldData?.customFieldConfig?.customFieldLabel ?? 'Font'}</div>
            <div className='v2-module-columns-holder'>
                <div className='v2-module-one-column grow v2-font-select-holder'>
                    <ModuleTextInput
                        // fieldLabel="F"
                        value={currentValue}
                        fieldId={'typography-font-face'}
                        enabled={currentValue ? true : false}
                        editable={false}
                        onChange={null}
                        onClick={() => {
                            slideOutPanelControl.openFontSelector(
                                currentValue,
                                (font) => {}, // Preview callback
                                (font) => { // Confirm callback
                                    changeFontFace(font);
                                },
                                'Select Font',
                                null, // fieldData
                                campaignContext?.campaignData?.customFonts || [],
                                campaignContext?.campaignData?._id
                            );
                        }}
                        maxLength={100}
                        fakeDropDown={true}
                    />
                </div>
                <div className='v2-module-one-column shrink'>
                    <AddButton onClick={() => {
                        slideOutPanelControl.openCustomFonts(
                            campaignContext?.campaignData?.customFonts || [],
                            campaignContext?.campaignData?._id,
                            campaignContext?.campaignData,
                            'Custom Fonts'
                        );
                    }} />
                </div>
            </div>
        </>
    );
};

export default FontSelectField;